export default "__VITE_ASSET__INM7wgiS__"